import React from "react";

const SelectTeacher = () => {
  return <div>Select Teacher Page</div>;
};

export default SelectTeacher;
